/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { ContactInformation } from './ContactInformation';
import {
    ContactInformationFromJSON,
    ContactInformationFromJSONTyped,
    ContactInformationToJSON,
    ContactInformationToJSONTyped,
} from './ContactInformation';
import { Mailbox, MailboxFromJSON, MailboxToJSON } from './Mailbox';
import { RewardsAccount, RewardsAccountFromJSON, RewardsAccountToJSON } from './RewardsAccount';
import { Role } from './Role';
import { RoleMapping } from './RoleMapping';
import { StoreLocation, StoreLocationFromJSON, StoreLocationToJSON } from './StoreLocation';

/**
 * 
 * @export
 * @interface CourierUser
 */
export interface CourierUser {
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    email?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof CourierUser
     */
    addresses?: Array<Address>;
    /**
     * 
     * @type {ContactInformation}
     * @memberof CourierUser
     */
    contactInformation?: ContactInformation;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    trnNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof CourierUser
     */
    createdOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourierUser
     */
    lastUpdatedOn?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    isProfileSet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof CourierUser
     */
    points?: number;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    couponCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    isBusiness?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CourierUser
     */
    isStaff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CourierUser
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CourierUser
     */
    deletedOn?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    subscribedToCommunication?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    realm?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    username?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    phoneVerified?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CourierUser
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierUser
     */
    referrerId?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierUser
     */
    storeLocationId?: number;

    /**
     * How the customer wants their packages handled: 'delivery', 'pickup' or
     * 'call_first' (deliver, but phone first). A legacy 'both' reads as
     * 'delivery'. Bulk delivery generation skips 'pickup' customers.
     * @type {string}
     * @memberof CourierUser
     */
    deliveryPreference?: string;

    /**
     * When the customer (or an admin) chose deliveryPreference. Unset means
     * never chosen — the 'delivery' default is then not a real choice.
     * Server-owned on updates.
     * @type {Date}
     * @memberof CourierUser
     */
    deliveryPreferenceSetAt?: Date;

    /**
     *
     * @type {string}
     * @memberof CourierUser
     */
    gender?: string;

    /**
     * 
     * @type {string}
     * @memberof CourierUser
     */
    dateOfBirth?: string;

    /**
     * 
     * @type {boolean}
     * @memberof CourierUser
     */
    insuranceOptIn?: boolean;

    mailboxes?: Mailbox[];
    rewardsAccount?: RewardsAccount;
    storeLocation?: StoreLocation;
    roles?: Role[];
    roleMappings?: RoleMapping[];
    stripeCustomerId?: string;
    subscriptionId?: string;
    subscriptionStatus?: string;
    /**
     * Whether this user is a courier/warehouse operator
     * @type {boolean}
     * @memberof CourierUser
     */
    isCourier?: boolean;
    businessName?: string;
    /**
     * Short prefix for manifest number generation (used for isCourier users)
     * @type {string}
     * @memberof CourierUser
     */
    prefix?: string;
    /**
     * Last used manifest number for auto-increment (used for isCourier users)
     * @type {number}
     * @memberof CourierUser
     */
    lastManifestNumber?: number;
}

/**
 * Check if a given object implements the CourierUser interface.
 */
export function instanceOfCourierUser(value: object): value is CourierUser {
    return true;
}

export function CourierUserFromJSON(json: any): CourierUser {
    return CourierUserFromJSONTyped(json, false);
}

export function CourierUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUser {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'contactInformation': json['contactInformation'] == null ? undefined : ContactInformationFromJSON(json['contactInformation']),
        'trnNumber': json['trnNumber'] == null ? undefined : json['trnNumber'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'lastUpdatedOn': json['lastUpdatedOn'] == null ? undefined : (new Date(json['lastUpdatedOn'])),
        'isProfileSet': json['isProfileSet'] == null ? undefined : json['isProfileSet'],
        'source': json['source'] == null ? undefined : json['source'],
        'points': json['points'] == null ? undefined : json['points'],
        'couponCode': json['couponCode'] == null ? undefined : json['couponCode'],
        'isBusiness': json['isBusiness'] == null ? undefined : json['isBusiness'],
        'isStaff': json['isStaff'] == null ? undefined : json['isStaff'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deletedOn': json['deletedOn'] == null ? undefined : (new Date(json['deletedOn'])),
        'subscribedToCommunication': json['subscribedToCommunication'] == null ? undefined : json['subscribedToCommunication'],
        'realm': json['realm'] == null ? undefined : json['realm'],
        'username': json['username'] == null ? undefined : json['username'],
        'emailVerified': json['emailVerified'] == null ? undefined : json['emailVerified'],
        'phoneVerified': json['phoneVerified'] == null ? undefined : json['phoneVerified'],
        'id': json['id'] == null ? undefined : json['id'],
        'referrerId': json['referrerId'] == null ? undefined : json['referrerId'],
        'storeLocationId': json['storeLocationId'] == null ? undefined : json['storeLocationId'],
        'deliveryPreference': json['deliveryPreference'] == null ? undefined : json['deliveryPreference'],
        'deliveryPreferenceSetAt': json['deliveryPreferenceSetAt'] == null ? undefined : (new Date(json['deliveryPreferenceSetAt'])),
        'mailboxes': json['mailboxes'] == null ? undefined : ((json['mailboxes'] as Array<any>).map(MailboxFromJSON)),
        'rewardsAccount': json['rewardsAccount'] == null ? undefined : RewardsAccountFromJSON(json['rewardsAccount']),
        'storeLocation': json['storeLocation'] == null ? undefined : StoreLocationFromJSON(json['storeLocation']),
        'gender': json['gender'] == null ? undefined : json['gender'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'insuranceOptIn': json['insuranceOptIn'] == null ? undefined : json['insuranceOptIn'],
        'stripeCustomerId': json['stripeCustomerId'] == null ? undefined : json['stripeCustomerId'],
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'isCourier': json['isCourier'] == null ? undefined : json['isCourier'],
        'businessName': json['businessName'] == null ? undefined : json['businessName'],
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'lastManifestNumber': json['lastManifestNumber'] == null ? undefined : json['lastManifestNumber'],
    };
}

export function CourierUserToJSON(json: any): CourierUser {
    return CourierUserToJSONTyped(json, false);
}

export function CourierUserToJSONTyped(value?: CourierUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(AddressToJSON)),
        'contactInformation': ContactInformationToJSON(value['contactInformation']),
        'trnNumber': value['trnNumber'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'lastUpdatedOn': value['lastUpdatedOn'] == null ? undefined : ((value['lastUpdatedOn']).toISOString()),
        'isProfileSet': value['isProfileSet'],
        'source': value['source'],
        'points': value['points'],
        'couponCode': value['couponCode'],
        'isBusiness': value['isBusiness'],
        'isStaff': value['isStaff'],
        'isDeleted': value['isDeleted'],
        'deletedOn': value['deletedOn'] == null ? undefined : ((value['deletedOn']).toISOString()),
        'subscribedToCommunication': value['subscribedToCommunication'],
        'realm': value['realm'],
        'username': value['username'],
        'emailVerified': value['emailVerified'],
        'phoneVerified': value['phoneVerified'],
        'id': value['id'],
        'referrerId': value['referrerId'],
        'storeLocationId': value['storeLocationId'],
        'deliveryPreference': value['deliveryPreference'],
        'deliveryPreferenceSetAt': value['deliveryPreferenceSetAt'] == null ? undefined : ((value['deliveryPreferenceSetAt']).toISOString()),
        'mailboxes': value['mailboxes'] == null ? undefined : ((value['mailboxes'] as Array<any>).map(MailboxToJSON)),
        'rewardsAccount': RewardsAccountToJSON(value['rewardsAccount']),
        'storeLocation': StoreLocationToJSON(value['storeLocation']),
        'gender': value['gender'],
        'dateOfBirth': value['dateOfBirth'],
        'insuranceOptIn': value['insuranceOptIn'],
        'stripeCustomerId': value['stripeCustomerId'],
        'subscriptionId': value['subscriptionId'],
        'subscriptionStatus': value['subscriptionStatus'],
        'isCourier': value['isCourier'],
        'businessName': value['businessName'],
        'prefix': value['prefix'],
        'lastManifestNumber': value['lastManifestNumber'],
    };
}


